import React, { useState } from "react";
import { Box, Text, Button, Grid, Label, Flex, Modal, ErrorMsg } from "atoms";
import { FormInput, FormSelect } from "molecules";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import MemoClose from "assets/icons/Close";
import { InvitationSentModal } from "molecules/Modals";

export const AddImageDescriptionModal = ({
  isOpen,
  onClose,
  preRecord,
  onSubmit,
  loading,
  isDesc,
  error,
}) => {
  const [isConfirmModalVisible, setConfirmModalVisible] = useState(false);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <Box width={{ md: "48.8rem" }}>
          <Box p={{ xs: "2.4rem", lg: "3.2rem" }}>
            <Flex
              justifyContent="space-between"
              borderBottom="0.1rem solid"
              borderColor="neutral.100"
              pb="2.4rem"
            >
              <Text
                fontSize="2rem"
                color="primary.900"
                fontFamily="primaryBold"
              >
                Add Description
              </Text>
              <Box
                color="neutral.900"
                onClick={onClose}
                cursor="pointer"
                textAlign="right"
              >
                <MemoClose height="1.6rem" width="1.6rem" />
              </Box>
            </Flex>
            <Formik
              initialValues={{
                ...(isDesc && { description: preRecord?.description || "" }),
                alt: preRecord?.alt || "",
              }}
              onSubmit={onSubmit}
              validationSchema={Yup.object().shape({
                ...(isDesc && {
                  description: Yup.string().required("Description is required"),
                }),
                alt: Yup.string().required("Alternative Text is required"),
              })}
            >
              {({ values, setFieldValue }) => {
                return (
                  <Form>
                    <Grid gridRowGap="2.4rem" mt="1.8rem">
                      {isDesc && (
                        <Grid gridRowGap="1.6rem">
                          <Label text="Add Description" req />
                          <FormInput
                            name="description"
                            placeholder="Enter Description"
                            type="textarea"
                            wrap="hard"
                            req
                            onChange={(e) => {
                              setFieldValue("description", e?.target?.value);
                            }}
                          />
                        </Grid>
                      )}

                      <Grid gridRowGap="1.6rem">
                        <Label text="Add Alternative Text" req />
                        <FormInput
                          name="alt"
                          placeholder="Enter Name"
                          autoFocus
                          req
                          onChange={(e) => {
                            setFieldValue("alt", e?.target?.value);
                          }}
                        />
                      </Grid>

                      {error && <ErrorMsg text={error} />}

                      <Button
                        variant="primary"
                        type="submit"
                        height={{ xs: "4.3rem", lg: "4.8rem" }}
                        loading={loading}
                      >
                        Add
                      </Button>
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </Box>
        </Box>
      </Modal>
      {isConfirmModalVisible && (
        <InvitationSentModal
          isOpen={isConfirmModalVisible}
          onClose={() => setConfirmModalVisible(false)}
        />
      )}
    </>
  );
};
